import { createSceneReducer } from 'reducers/reducers-util';
import companiesUIReducer from 'components/admin/companies/store/reducers.ui';

export default createSceneReducer(null, companiesUIReducer);
